import React from "react";
import { Box } from "@mui/material";
import Field from "../shared/Field";

const FormMeta = ({ data, onChange }) => {
  const handleTitleChange = (v) => {
    const slug = v
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "");
    onChange({ ...data, title: v, slug });
  };

  return (
    <Box>
      <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
        <Field
          label="Page Title"
          value={data.title}
          onChange={handleTitleChange}
          placeholder="e.g. MERN Stack Agency"
        />
        <Field
          label="Slug (URL)"
          value={data.slug}
          onChange={(v) => onChange({ ...data, slug: v })}
          placeholder="e.g. mern-stack-agency"
          hint="Auto-generated from title"
        />
      </Box>
    </Box>
  );
};

export default FormMeta;
